



import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
@Component({
  components: { AdminIframe },
})
export default class PartnerModificationIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const { query, params } = this.$route;
    const queryObject = { ...query, partnerNo: params.partnerNo, serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + '/configuration/partner/modification?' + queryString;
  }

  created() {
    this.setRemoteSrc();
  }
}
